import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { breweryRequest } from '@/pages/breweries/api';
import endpoints from '@/api/endpoints';
import type { IMenuSettingsResponse } from '@/services/menuSettings/interface';

export const menuSettingsKeys = {
  all: ['menuSettings'] as const,
};

export const useGetMenuSettings = () => {
  return useQuery({
    queryKey: menuSettingsKeys.all,
    queryFn: async () => {
      return /^\/breweries(?:\/|$)/i.test(window.location.pathname)
        ? breweryRequest<IMenuSettingsResponse>({ url: endpoints.menuSettings })
        : api.get<IMenuSettingsResponse>(endpoints.menuSettings);
    },
  });
};
